import React from "react";
import DialogBox from "./dialog-box";

const UploadProjectImage = ({ projectCoverImage, project }) => {
  return (
    <React.Fragment>
      <DialogBox projectCoverImage={projectCoverImage} project={project} />
    </React.Fragment>
  );
};

export default UploadProjectImage;
